<template>
  <div>
    <vx-card>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-full w-full">

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >아이디</h5>
            <div class="vx-col mb-2">
              필수
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >비밀번호</h5>
            <div class="vx-col  mb-2">
              필수
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >이메일</h5>
            <div class="vx-col mb-2">
              필수
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col" >이름</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >자택주소</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >생년월일</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col" >휴대폰</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >회사주소</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >직책</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >직급</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >부서</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >회사전화번호</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col " >메일수신여부</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col" >SMS수신여부</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col" >회원가입약관</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>
          <div class="vx-row mb-2">
            <h5 class="flex vx-col" ></h5>
            <div class="flex flex-wrap items-center vx-row pl-4 mb-2">
              <quill-editor class="editor vx-col flex-1 ql-edit-text"></quill-editor>
            </div>
          </div>

          <div class="vx-row mb-2">
            <h5 class="flex vx-col" >개인정보취급방침</h5>
            <div class="vx-col mb-2">
              <vs-radio class="mr-5" value="">사용</vs-radio>
              <vs-radio value="">사용안함</vs-radio>
            </div>
          </div>
          <div class="vx-row mb-2">
            <h5 class="flex vx-col " ></h5>
            <div class="flex flex-wrap items-center vx-row pl-4 mb-2">
              <quill-editor class="editor vx-col flex-1 ql-edit-text"></quill-editor>
            </div>
          </div>

        </div>
      </div>

      <vs-row class="w-full mt-8" vs-justify="center">
        <vs-button class="sm:w-2/12 mr-4 large" color="secondary" >저장</vs-button>
        <vs-button class="sm:w-2/12 large" color="#EDEDED" text-color="black" type="filled" >취소</vs-button>
      </vs-row>

    </vx-card>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'Register',
  components: {quillEditor}
}
</script>

<style scoped>
h5 {width:160px; align-text:right; display: flex; justify-content: flex-end}
.editor /deep/ .ql-container{
  height: 250px;
}
</style>
